import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { NumberColumn } from '../types/grid';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface NumberColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, number> {
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
}
export type ServerSideNumberColumnOptions<TRow extends object> = NumberColumnOptions<TRow> & ServerSideColumnOption;


export function numberColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                  options: NumberColumnOptions<TRow> | ServerSideNumberColumnOptions<TRow>): NumberColumn<TRow> {
  const column: NumberColumn<TRow> = {
    ...options,
    type: 'number',
    format: options.format ?? 'NUMBER.DEFAULT'
  }
  ref.createColumn(column);
  return column;
}
